/* The Hollow Harvest · C7 (20/10/2026) · le pagine di servizio dentro il registro della parrocchia.
   Mette la voce del registro e la tacca con la spiga sopra ogni capitolo (informative, articoli, pagine di testo),
   costruisce l'indice "In questa pagina" sulle informative, numera le schede dei contatti e accende gli ingressi.
   Il testo non cambia mai: se un capitolo ha gia' il suo numero ("1. Chi vende"), quel numero viene solo avvolto
   e spostato nel cerchio; il punto resta per chi ascolta col lettore di schermo. Gli id che ci sono si tengono.
   Ordine anti-lampo: prima si inserisce tutto, poi si misura, poi chi e' gia' nello schermo e' subito "dentro",
   solo allora html.hhq-pronto (che nasconde il resto) e l'osservatore. Con reduce niente hhq-pronto: tutto fermo. */
(function () {
  'use strict';
  var sc = document.currentScript;
  var ETICHETTA = (sc && sc.getAttribute('data-hhq-indice')) || 'On this page';
  var radice = document.documentElement;
  var muovi = !window.matchMedia || window.matchMedia('(prefers-reduced-motion: no-preference)').matches;
  var ROMANI = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII', 'XIII', 'XIV', 'XV', 'XVI', 'XVII', 'XVIII', 'XIX', 'XX'];
  var SEP = '<svg viewBox="0 0 120 24" focusable="false"><path class="hhq-sep__l" pathLength="1" d="M8 12H49M71 12H112M8 7v10M112 7v10"/>' +
    '<path class="hhq-sep__s" d="M60 22V3M60 8c-3-1-4.5-3-4.5-5.5 2.2.4 4.5 2.4 4.5 5.5zm0 0c3-1 4.5-3 4.5-5.5-2.2.4-4.5 2.4-4.5 5.5zM60 13.5c-3-1-4.5-3-4.5-5.5 2.2.4 4.5 2.4 4.5 5.5zm0 0c3-1 4.5-3 4.5-5.5-2.2.4-4.5 2.4-4.5 5.5zM60 19c-3-1-4.5-3-4.5-5.5 2.2.4 4.5 2.4 4.5 5.5zm0 0c3-1 4.5-3 4.5-5.5-2.2.4-4.5 2.4-4.5 5.5z"/></svg>';

  function nuovo(tag, classe, testo) {
    var e = document.createElement(tag);
    if (classe) e.className = classe;
    if (testo != null) e.textContent = testo;
    return e;
  }
  function tacca() {
    var s = nuovo('span', 'hhq-sep');
    s.setAttribute('aria-hidden', 'true');
    s.innerHTML = SEP;
    return s;
  }
  function romano(i) { return ROMANI[i] || String(i + 1); }

  /* "1. Chi vende": il numero e il punto restano nel testo, il numero va nel cerchio */
  function numero(h) {
    var t = h.firstChild;
    while (t && t.nodeType === 3 && !t.nodeValue.trim()) t = t.nextSibling;
    if (!t || t.nodeType !== 3) return null;
    var m = /^(\s*)(\d{1,2})(\.\s*)/.exec(t.nodeValue);
    if (!m) return null;
    var v = nuovo('span', 'hhq-h2-voce hhq-num', m[2]);
    v.appendChild(nuovo('span', 'hhq-num__p', m[3]));
    t.nodeValue = t.nodeValue.slice(m[0].length);
    if (m[1]) h.insertBefore(document.createTextNode(m[1]), t);
    h.insertBefore(v, t);
    return m[2];
  }

  /* i capitoli di un documento: voce, tacca, id stabili (uguali in tutte e tre le lingue) */
  function capitoli(corpo) {
    var hh = [].slice.call(corpo.querySelectorAll('h2')).filter(function (h) { return !h.closest('.hhq-indice'); });
    if (!hh.length) return [];
    var numerati = hh.some(function (h) { return /^\s*\d{1,2}\.\s/.test(h.textContent); });
    var r = 0;
    return hh.map(function (h, i) {
      var etich = null;
      if (numerati) {
        etich = numero(h);
        if (!etich) h.classList.add('hhq-senza-voce');
      } else {
        etich = romano(r++);
        var v = nuovo('span', 'hhq-h2-voce', etich);
        v.setAttribute('aria-hidden', 'true');
        h.insertBefore(v, h.firstChild);
      }
      var s = tacca();
      if (h.firstChild && h.firstChild.classList && h.firstChild.classList.contains('hhq-h2-voce')) h.insertBefore(s, h.firstChild.nextSibling);
      else h.insertBefore(s, h.firstChild);
      if (!h.id) h.id = 'voce-' + (i + 1);
      h.setAttribute('data-hhq-in', '');
      return { h: h, voce: etich };
    });
  }

  /* il testo del capitolo senza il numero gia' spostato nel cerchio */
  function titolo(h) {
    var c = h.cloneNode(true);
    [].forEach.call(c.querySelectorAll('.hhq-h2-voce, .hhq-sep'), function (e) { e.remove(); });
    return c.textContent.replace(/\s+/g, ' ').trim();
  }

  function indice(voci) {
    var nav = nuovo('nav', 'hhq-indice');
    nav.setAttribute('aria-label', ETICHETTA);
    nav.setAttribute('data-hhq-in', '');
    var d = nuovo('details');
    var s = nuovo('summary');
    s.appendChild(nuovo('span', 'hhq-indice__t', ETICHETTA));
    var piu = nuovo('span', 'hhq-indice__piu');
    piu.setAttribute('aria-hidden', 'true');
    s.appendChild(piu);
    d.appendChild(s);
    var ol = nuovo('ol');
    voci.forEach(function (x, i) {
      var li = nuovo('li');
      li.style.setProperty('--i', i);
      var a = nuovo('a');
      a.href = '#' + x.h.id;
      var v = nuovo('span', 'hhq-indice__v', x.voce || '');
      v.setAttribute('aria-hidden', 'true');
      a.appendChild(v);
      a.appendChild(nuovo('span', 'hhq-indice__l', titolo(x.h)));
      li.appendChild(a);
      ol.appendChild(li);
      x.a = a;
    });
    d.appendChild(ol);
    nav.appendChild(d);
    return { nav: nav, details: d, summary: s };
  }

  /* la voce che stai leggendo, segnata nell'indice */
  function segnaLettura(voci) {
    if (!('IntersectionObserver' in window)) return;
    var per = {};
    voci.forEach(function (x) { per[x.h.id] = x.a; });
    var ora = null;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var a = per[e.target.id];
        if (!a || a === ora) return;
        if (ora) ora.removeAttribute('aria-current');
        a.setAttribute('aria-current', 'location');
        ora = a;
      });
    }, { rootMargin: '-20% 0px -70% 0px' });
    voci.forEach(function (x) { io.observe(x.h); });
  }

  /* arrivando a un capitolo dall'indice, la sua voce si timbra di nuovo */
  function ritimbra(h) {
    if (!muovi || !h || !h.getAnimations) return;
    h.classList.add('is-in');
    [].forEach.call(h.querySelectorAll('.hhq-h2-voce, .hhq-sep__l, .hhq-sep__s'), function (e) {
      e.getAnimations().forEach(function (an) { an.cancel(); an.play(); });
    });
  }

  /* ------------------------------------------------------------ le informative */
  var cont = document.querySelector('.shopify-policy__container');
  var corpoPol = cont && cont.querySelector('.shopify-policy__body .rte');
  if (corpoPol) {
    var vociPol = capitoli(corpoPol);
    /* l'indice solo con almeno tre capitoli: e' la stessa condizione con cui il CSS tiene il posto (h2 ~ h2 ~ h2) */
    if (vociPol.length && corpoPol.querySelector('h2 ~ h2 ~ h2')) {
      var ind = indice(vociPol);
      var tit = cont.querySelector('.shopify-policy__title');
      cont.insertBefore(ind.nav, tit ? tit.nextSibling : cont.firstChild);
      cont.classList.add('hhq-con-indice');
      var largo = window.matchMedia ? window.matchMedia('(min-width: 1200px)') : null;
      var adatta = function () { ind.details.open = !!(largo && largo.matches); };
      adatta();
      if (largo) {
        if (largo.addEventListener) largo.addEventListener('change', adatta); else if (largo.addListener) largo.addListener(adatta);
      }
      /* a lato l'indice resta aperto: e' una colonna, non un menu */
      ind.summary.addEventListener('click', function (ev) { if (largo && largo.matches) ev.preventDefault(); });
      segnaLettura(vociPol);
    }
  }

  /* ------------------------------------------------------------ articoli e pagine di testo: solo voci e tacche */
  [].forEach.call(document.querySelectorAll('.article-template__content, main[data-template="page"] .rte'), function (c) {
    if (c.querySelector('.hhc')) return;
    capitoli(c);
  });

  /* ------------------------------------------------------------ contatti: le tre schede prendono la loro voce */
  var griglia = document.querySelector('.rte .hhc-grid');
  if (griglia) {
    [].forEach.call(griglia.querySelectorAll('.hhc-card'), function (c, i) {
      var v = nuovo('span', 'hhq-voce', romano(i));
      v.setAttribute('aria-hidden', 'true');
      c.insertBefore(v, c.firstChild);
    });
    griglia.setAttribute('data-hhq-in', '');
  }

  /* ------------------------------------------------------------ 404: nel registro va l'indirizzo cercato davvero (Liquid vede solo "/404") */
  var cercata = document.querySelector('.hhq-reg__testo');
  if (cercata) {
    var via = location.pathname;
    try { via = decodeURIComponent(via); } catch (e) { /* resta com'e' */ }
    via = via.replace(/^\/(it|de|en)(?=\/|$)/i, '') || '/';
    cercata.textContent = via;
  }

  window.addEventListener('hashchange', function () {
    var id = '';
    try { id = decodeURIComponent(location.hash.slice(1)); } catch (e) { id = location.hash.slice(1); }
    var h = id && document.getElementById(id);
    if (h && h.matches('h2[data-hhq-in]')) ritimbra(h);
  });

  /* ------------------------------------------------------------ il tocco: a telefono la mano sopra non esiste */
  /* l'avviso del blog dondola sul chiodo e il foglio della 404 si raddrizza anche al tocco o al clic (i link restano link) */
  [].forEach.call(document.querySelectorAll('.hhq-avviso__foglio, .hhq-reg__foglio'), function (f) {
    f.addEventListener('click', function (ev) {
      if (ev.target.closest('a, button, input, textarea')) return;
      if (f.classList.contains('hhq-reg__foglio')) { f.classList.toggle('is-tocco'); return; }
      if (!muovi || !f.animate) return;
      f.animate([{ transform: 'rotate(-1.4deg)' }, { transform: 'rotate(2.4deg)', offset: .22 }, { transform: 'rotate(-1.8deg)', offset: .48 },
        { transform: 'rotate(.9deg)', offset: .74 }, { transform: 'rotate(-1.4deg)' }], { duration: 1500, easing: 'cubic-bezier(.16, 1, .3, 1)' });
    });
  });

  /* ------------------------------------------------------------ gli ingressi */
  var tutti = [].slice.call(document.querySelectorAll('[data-hhq-in]'));
  var alto = window.innerHeight || radice.clientHeight;
  var fuori = [];
  tutti.forEach(function (el) {
    var r = el.getBoundingClientRect();
    if (r.bottom > 0 && r.top < alto && (r.width || r.height)) dentro(el);
    else fuori.push(el);
  });
  function dentro(el) {
    el.classList.add('is-in');
    /* finita l'entrata, le schede non si portano dietro il ritardo a scalare quando le sfiori */
    if (el.classList.contains('hhc-grid')) setTimeout(function () { el.classList.add('hhq-fatto'); }, 1300);
  }
  radice.classList.add('hhq-js');
  if (!muovi || !('IntersectionObserver' in window)) {
    fuori.forEach(dentro);
    return;
  }
  radice.classList.add('hhq-pronto');
  var oss = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      dentro(e.target);
      oss.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
  fuori.forEach(function (el) { oss.observe(el); });
})();
